import React, { useState } from 'react';
import { Button } from 'primereact/button';
import './../Forgetpassword/Forget.scss';
import { useFormik } from 'formik';
import classNames from 'classnames';
import { InputText } from 'primereact/inputtext';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { handlePostRequest } from '../../services/PostTemplate';

const GenerateOTP = ({ handleGenerateOtp }) => {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch(); // Initialize Redux dispatch

    const formik = useFormik({
        initialValues: {
            email: ''
        },
        validate: (data) => {
            let errors = {};

            if (!data.email) {
                errors.email = 'Email is required.';
            }
            return errors;
        },
        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon('pi pi-spin pi-spinner');

            const newData = {
                email: data.email
            };

            try {
                console.log('data', newData);
                const res = await dispatch(handlePostRequest(newData, '/api/Auth/forgot', true, true, '', '', true));

                if (res?.success === true) {
                    handleGenerateOtp(res?.payLoad);
                }
            } catch (error) {
                console.error('Error:', error);
            } finally {
                setloading(false);
                setloadingIcon('pi pi-save');
                formik.resetForm();
            }
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <div className="Forget__Body">
            <div className="container" id="container">
                <div className="form-container sign-in-container">
                    <form action="#" className="Login__Form" onSubmit={formik.handleSubmit}>
                        <div className="p-mb-4">
                            <h3 className="forgetHeading">FORGOT PASSWORD</h3>
                        </div>
                        <div className="p-mt-4">
                            <div className="p-text-left">
                                <label htmlFor="email" className={classNames({ 'p-error': isFormFieldValid('email') })}>
                                    Email
                                </label>
                                <InputText
                                    size="small"
                                    className={classNames({ 'p-invalid': isFormFieldValid('email') }, 'Forget__Input')}
                                    name="email"
                                    placeholder="Enter Email"
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    type="email"
                                />
                                {getFormErrorMessage('email')}
                            </div>
                            <div className="p-mt-4">
                                <Button type="submit" loadingIcon={loadingIcon} disabled={loading} className="Login__Button" label="Submit" iconPos="right" style={{ height: '45px' }} />
                                <Button className="Cancel_Pass" label="Cancel" iconPos="right" onClick={() => navigate('/')} style={{ height: '45px' }} />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default GenerateOTP;
